/**
 * Groups purchased tickets strictly by ticket type id — never by name, since
 * promoters create distinct ticket types that can share a name (e.g. several
 * "DONATION" tickets at different prices).
 *
 * `ticket_id` is the ticket type's id. `id` is the individual pass id and is
 * only a fallback so tickets from responses without `ticket_id` render as
 * individual rows instead of merging incorrectly.
 */
const groupTicketsByTypeId = (tickets) => {
  const groups = new Map();

  (tickets || []).forEach((ticket) => {
    const key = ticket.ticket_id ?? ticket.id;
    const group = groups.get(key);

    if (group) {
      group.count += 1;
    } else {
      groups.set(key, {
        key,
        count: 1,
        name: ticket.name || 'Unknown',
        priceDisplay: ticket.price || ticket.amount || '$0.00',
      });
    }
  });

  return Array.from(groups.values());
};

export default groupTicketsByTypeId;
